<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    transition="slide-y-reverse-transition"
    @keydown.esc="dialogVisible = false"
  >
    <invoice-form-component
      @onDismiss="dismiss"
      :invoiceId="invoiceId"
      v-if="dialogVisible"
      :documentType="documentType"
      :projectId="projectId"
      :bookingId="bookingId"
      :contractData="contractData"
      :canSend="canSend"
      @onSaveSuccess="onSaveSuccess"
      @onSendSuccess="$emit('onSendSuccess')"
      @onUnSendSuccess="onUnSendSuccess"
      @onRemoveSuccess="onRemoveSuccess"
      :isLoading="isLoading"
    />
  </v-dialog>
</template>
<script>
import InvoiceFormComponent from "../components/InvoiceForm.component.vue";
export default {
  props: {
    value: Boolean,
    invoiceId: String,
    projectId: String,
    documentType: Number,
    contractData: Object,
    mode: String,
    bookingId: String,
    canSend:{
      default:true,
      type:Boolean
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  components: {
    InvoiceFormComponent
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false
    };
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    onSaveSuccess(data) {
      this.$emit("onSaveSuccess", data);
      // console.log("emit test 1");
    },
    onSendSuccess(data) {
      this.$emit("onSendSuccess", data);
      // console.log("emit test 2");
    },
    onUnSendSuccess(data) {
      this.$emit("onUnSendSuccess", data);
      // console.log("emit test 3");
    },
    onRemoveSuccess(data) {
      this.$emit("onRemoveSuccess", data);
    },
    async checkoutData() {
      try {
        await this.$store.dispatch("contractCheckout/getContractCheckoutData");
      } catch (e) {
        this.$toast.show({
          content: "Data not found",
          color: "error"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.card-receipt-form {
  height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
